module.exports = __webpack_public_path__ + "img/novin.719868fa.png";